import { Injectable } from '@angular/core';
import { getToken, AppCheck } from 'firebase/app-check';

@Injectable({ providedIn: 'root' })
export class AppCheckService {
  /**
   * Returns the current App Check token, or null if it cannot be obtained.
   */
  async getToken(): Promise<string | null> {
    try {
      const appCheck = (window as any).__appCheck as AppCheck | undefined;
      if (!appCheck) {
        console.warn('AppCheck instance not initialized');
        return null;
      }

      const result = await getToken(appCheck, false);
      return result.token;
    } catch (err) {
      console.warn('Failed to get App Check token', err);
      return null;
    }
  }
}
